import { render, staticRenderFns } from "./AddNewsReviewForm.vue?vue&type=template&id=20df475d&"
import script from "./AddNewsReviewForm.vue?vue&type=script&lang=js&"
export * from "./AddNewsReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports